/**
 * Genera layouts compactos para breakpoints estrechos a partir de los widgets
 * (ordenados según el layout lg si existe).
 */

function sortWidgetsByLayout(widgets, lgLayout = []) {
  const pos = new Map((lgLayout || []).map((l) => [l.i, l]));
  return [...widgets].sort((a, b) => {
    const la = pos.get(a.i);
    const lb = pos.get(b.i);
    if (!la && !lb) return 0;
    if (!la) return 1;
    if (!lb) return -1;
    if (la.y !== lb.y) return la.y - lb.y;
    return la.x - lb.x;
  });
}

/**
 * @param {Array} widgets
 * @param {number} cols - columnas del breakpoint
 * @param {object} opts
 */
export function buildCompactLayout(widgets, cols, { lgLayout } = {}) {
  const ordered = sortWidgetsByLayout(widgets, lgLayout);
  const layout = [];
  let x = 0;
  let y = 0;
  let rowH = 0;

  const advanceRow = () => {
    y += rowH || 2;
    x = 0;
    rowH = 0;
  };

  ordered.forEach((widget) => {
    const isData = widget.type === "data";
    // Móvil (2 cols): atajos 1 col (2 por fila); datos a ancho completo.
    // Tablet+: atajos de 2 unidades.
    const w = isData ? cols : cols <= 2 ? 1 : Math.min(2, cols);
    const h = isData ? (cols <= 2 ? 5 : 4) : cols <= 2 ? 2 : 3;

    if (x + w > cols) advanceRow();

    layout.push({
      i: widget.i,
      x,
      y,
      w,
      h,
      minW: 1,
      minH: 2,
    });

    x += w;
    rowH = Math.max(rowH, h);
    if (x >= cols) advanceRow();
  });

  return layout;
}

export const DASH_BREAKPOINTS = { lg: 1100, md: 800, sm: 560, xs: 0 };
export const DASH_COLS = { lg: 12, md: 8, sm: 4, xs: 2 };

/**
 * Completa layouts responsive. lg se conserva; md/sm/xs se regeneran
 * para que móvil no herede el grid de 12 columnas.
 */
export function ensureResponsiveLayouts(widgets, layouts = {}) {
  const lg = Array.isArray(layouts.lg) ? layouts.lg : [];
  return {
    lg,
    md: buildCompactLayout(widgets, DASH_COLS.md, { lgLayout: lg }),
    sm: buildCompactLayout(widgets, DASH_COLS.sm, { lgLayout: lg }),
    xs: buildCompactLayout(widgets, DASH_COLS.xs, { lgLayout: lg }),
  };
}
